/**
 * Extract numeric value from formatted price string.
 *
 * @since 1.0.0
 */

import { formatPrice } from '../format-price';

/**
 * Extract numeric value from formatted price string.
 *
 * @since 1.0.0
 *
 * @param priceString - The price string or number to extract from.
 * @return Numeric price value or 0 if extraction fails.
 */
export const extractNumericPrice = (priceString: string | number): number => {
  if (typeof priceString === 'number') {
    return priceString;
  }

  // Clean the string and extract numeric value
  const cleaned = formatPrice(priceString);
  const numericMatch = cleaned.match(/[\d.,]+/);

  if (numericMatch) {
    const numericString = numericMatch[0].replace(/,/g, '');
    return parseFloat(numericString) || 0;
  }

  return 0;
};
